export { mapDtoToArticles } from "./mappers";
export type { NewsListType } from "./types";
